import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';

import { AppointmentComponent } from './Module/Security/Dialog/appointment/appointment.component';
import { GatePassComponent } from './Module/Security/Dialog/gate-pass/gate-pass.component';
import { PermissionComponent } from './Module/Security/Dialog/permission/permission.component';
import { CreateNotificationComponent } from './Module/MessageCenter/Messaging/notification/create-notification/create-notification.component';

import { NotAuthorizedComponent } from './common/not-authorized/not-authorized.component';

import { HRDashboardComponent } from './Module/HR1/hrdashboard/hrdashboard.component';
import { OktaLoginComponent } from './okta-login/okta-login.component';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';
import { NotificationComponent } from './common/notification/notification.component';
import { MonitoringDashboardComponent } from './monitoring-dashboard/monitoring-dashboard.component';
import { LoginComponent } from './common/login/login/login.component';
import { CapitalFoodsComponent } from './Module/Order/WebOrder/capital-foods/capital-foods.component';
import { PermissionAdminComponent } from './Module/Order/WebOrder/capital-foods/permission-admin/permission-admin.component';
import { ModuleMaintenanceComponent } from './common/module-maintenance/module-maintenance.component';

const routes: Routes = [

  {
    path: 'store-operation',
    children: [
      {
        path: "attendance",
        loadChildren: () =>
          import("./ModuleAndRouting/StoreOperation/store-operation-attendance/store-operation-attendance.module")
            .then((m) => m.StoreOperationAttendanceModule),
      },
      {
        path: "manage-staff",
        loadChildren: () =>
          import("./ModuleAndRouting/StoreOperation/store-operation-manage-staff/store-operation-manage-staff.module")
            .then((m) => m.StoreOperationManageStaffModule),
      },
      {
        path: "store-approval",
        loadChildren: () =>
          import("./ModuleAndRouting/StoreOperation/store-operation-store-approval/store-operation-store-approval.module")
            .then((m) => m.StoreOperationStoreApprovalModule),
      },
      {
        path: "store-care",
        loadChildren: () =>
          import("./ModuleAndRouting/StoreOperation/store-operation-store-care/store-operation-store-care.module")
            .then((m) => m.StoreOperationStoreCareModule),
      },
      {
        path: "wholesale-customer",
        loadChildren: () =>
          import("./ModuleAndRouting/StoreOperation/store-operation-wholesale-customer/store-operation-wholesale-customer.module")
            .then((m) => m.StoreOperationWholesaleCustomerModule),
      },
      {
        path: "store-feedback",
        loadChildren: () =>
          import("./ModuleAndRouting/StoreOperation/store-operation-store-feedback/store-feedback/store-feedback.module")
            .then((m) => m.StoreFeedbackModule)
      },
      {
        path: "store-reporting",
        loadChildren: () =>
          import("./ModuleAndRouting/StoreOperation/store-operation-store-reporting/store-operation-reporting/store-operation-reporting.module")
            .then((m) => m.StoreOperationReportingModule)
      }
    ]
  },

  {
    path: 'sale',
    children: [
      {
        path: "pos",
        loadChildren: () =>
          import("./ModuleAndRouting/Sale/sale-pos/sale-pos.module").then((m) => m.SalePosModule),
      },
      {
        path: "invoice",
        loadChildren: () =>
          import("./ModuleAndRouting/Sale/sale-invoice/sale-invoice.module").then((m) => m.SaleInvoiceModule),
      }
    ]
  },

  {
    path: 'purchase',
    children: [
      {
        path: "invoice",
        loadChildren: () =>
          import("./ModuleAndRouting/Purchase/purchase-invoice/purchase-invoice.module").then((m) => m.PurchaseInvoiceModule),
      }
    ]
  },

  {
    path: 'order',
    children: [
      {
        path: "order",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order/order.module").then((m) => m.OrderModule),
      },
      {
        path: "crate",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-crate/order-crate.module").then((m) => m.OrderCrateModule),
      },
      {
        path: "delivery",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-delivery/order-delivery.module").then((m) => m.OrderDeliveryModule),
      },
      {
        path: "dispatch",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-dispatch/order-dispatch.module").then((m) => m.OrderDispatchModule),
      },
      {
        path: "process",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-process/order-process.module").then((m) => m.OrderProcessModule),
      },
      {
        path: "receive",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-receive/order-receive.module").then((m) => m.OrderReceiveModule),
      },
      {
        path: "receive-return",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-receive-return/order-receive-return.module").then((m) => m.OrderReceiveReturnModule),
      },
      {
        path: "return",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-return/order-return.module").then((m) => m.OrderReturnModule),
      },
      {
        path: "shipping-management",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-shipping-management/order-shipping-management.module").then((m) => m.OrderShippingManagementModule),
      },
      {
        path: "track",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-track/order-track.module").then((m) => m.OrderTrackModule),
      },
      {
        path: "web-order",
        loadChildren: () =>
          import("./ModuleAndRouting/Order/order-web-order/order-web-order.module").then((m) => m.OrderWebOrderModule),
      }
    ]
  },

  {
    path: 'inventory',
    children: [
      {
        path: "inventory-control",
        loadChildren: () =>
          import("./ModuleAndRouting/Inventory/inventory-control/inventory-control.module").then((m) => m.InventoryControlModule),
      },
      {
        path: "stock-flow",
        loadChildren: () =>
          import("./ModuleAndRouting/Inventory/inventory-stock-flow/inventory-stock-flow.module").then((m) => m.InventoryStockFlowModule),
      },
      {
        path: "warehouse",
        loadChildren: () =>
          import("./ModuleAndRouting/Inventory/inventory-warehouse/inventory-warehouse.module").then((m) => m.InventoryWarehouseModule),
      }
    ]
  },

  {
    path: 'production',
    children: [
      {
        path: "manage-production",
        loadChildren: () =>
          import("./ModuleAndRouting/Production/manage-production/manage-production.module").then((m) => m.ManageProductionModule),
      },
      {
        path: "organise-production",
        loadChildren: () =>
          import("./ModuleAndRouting/Production/organise-production/organise-production.module").then((m) => m.OrganiseProductionModule),
      },
      {
        path: "production-loss",
        loadChildren: () =>
          import("./ModuleAndRouting/Production/production-loss/production-loss.module").then((m) => m.ProductionLossModule),
      },
      {
        path: "view-order",
        loadChildren: () =>
          import("./ModuleAndRouting/Production/production-view-order/production-view-order.module").then((m) => m.ProductionViewOrderModule),
      }
    ]
  },

  {
    path: 'process',
    children: [
      {
        path: "manage",
        loadChildren: () =>
          import("./ModuleAndRouting/Process/manage-process/manage-process.module").then((m) => m.ManageProcessModule),
      },
      {
        path: "schedule",
        loadChildren: () =>
          import("./ModuleAndRouting/Process/schedule-process/schedule-process.module").then((m) => m.ScheduleProcessModule),
      }
    ]
  },

  {
    path: 'account',
    children: [
      {
        path: "costing-and-budgeting",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-costing-and-budgeting/account-costing-and-budgeting.module").then((m) => m.AccountCostingAndBudgetingModule),
      },
      {
        path: "expenses",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-expenses/account-expenses.module").then((m) => m.AccountExpensesModule),
      },
      {
        path: "ledger",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-ledger/account-ledger.module").then((m) => m.AccountLedgerModule),
      },
      {
        path: "pay",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-pay/account-pay.module").then((m) => m.AccountPayModule),
      },
      {
        path: "receipts",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-receipts/account-receipts.module").then((m) => m.AccountReceiptsModule),
      },
      {
        path: "refunds",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-refunds/account-refunds.module").then((m) => m.AccountRefundsModule),
      },
      {
        path: "statements",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-statements/account-statements.module").then((m) => m.AccountStatementsModule),
      },
      {
        path: "vouchers",
        loadChildren: () =>
          import("./ModuleAndRouting/Account/account-vouchers/account-vouchers.module").then((m) => m.AccountVouchersModule),
      }
    ]
  },

  {
    path: 'gst',
    children: [
      {
        path: "delivery-challan",
        loadChildren: () =>
          import("./ModuleAndRouting/Gst/gst-delivery-challan/gst-delivery-challan.module").then((m) => m.GstDeliveryChallanModule),
      },
      {
        path: "gst-reports",
        loadChildren: () =>
          import("./ModuleAndRouting/Gst/gst-reports/gst-reports.module").then((m) => m.GstReportsModule),
      }
    ]
  },

  {
    path: 'resource-control',
    children: [
      {
        path: "asset",
        loadChildren: () =>
          import("./ModuleAndRouting/ResourceControl/resource-control-asset/resource-control-asset.module").then((m) => m.ResourceControlAssetModule),
      },
      {
        path: "compliance",
        loadChildren: () =>
          import("./ModuleAndRouting/ResourceControl/resource-control-compliance/resource-control-compliance.module").then((m) => m.ResourceControlComplianceModule),
      },
      {
        path: "facility-manager",
        loadChildren: () =>
          import("./ModuleAndRouting/ResourceControl/resource-control-facility-manager/resource-control-facility-manager.module").then((m) => m.ResourceControlFacilityManagerModule),
      },
      {
        path: "maintenance",
        loadChildren: () =>
          import("./ModuleAndRouting/ResourceControl/resource-control-maintenance/resource-control-maintenance.module").then((m) => m.ResourceControlMaintenanceModule),
      },
      {
        path: "performance",
        loadChildren: () =>
          import("./ModuleAndRouting/ResourceControl/resource-control-performance/resource-control-performance.module").then((m) => m.ResourceControlPerformanceModule),
      },
      {
        path: "warranty",
        loadChildren: () =>
          import("./ModuleAndRouting/ResourceControl/resource-control-warranty/resource-control-warranty.module").then((m) => m.ResourceControlWarrantyModule),
      }
    ]
  },

  {
    path: 'security',
    children: [
      {
        path: "material",
        loadChildren: () =>
          import("./ModuleAndRouting/Security/security-material/security-material.module").then((m) => m.SecurityMaterialModule),
      },
      {
        path: "vendor",
        loadChildren: () =>
          import("./ModuleAndRouting/Security/security-vendor/security-vendor.module").then((m) => m.SecurityVendorModule),
      },
      {
        path: "visitor",
        loadChildren: () =>
          import("./ModuleAndRouting/Security/security-visitor/security-visitor.module").then((m) => m.SecurityVisitorModule),
      }
    ]
  },

  {
    path: 'message-center',
    children: [
      {
        path: "messaging",
        loadChildren: () =>
          import("./ModuleAndRouting/MessageCenter/message-center-messaging/message-center-messaging.module").then((m) => m.MessageCenterMessagingModule),
      }
    ]
  },

  {
    path: 'crm',
    children: [
      {
        path: "digiboard",
        loadChildren: () =>
          import("./ModuleAndRouting/CRM/crm-digiboard/crm-digiboard.module").then((m) => m.CrmDigiboardModule),
      },
      {
        path: "promotions",
        loadChildren: () =>
          import("./ModuleAndRouting/CRM/crm-promotions/crm-promotions.module").then((m) => m.CrmPromotionsModule),
      },
      {
        path: "survey",
        loadChildren: () =>
          import("./ModuleAndRouting/CRM/crm-survey/crm-survey.module").then((m) => m.CrmSurveyModule),
      },
      {
        path: "tools",
        loadChildren: () =>
          import("./ModuleAndRouting/CRM/crm-tools/crm-tools.module").then((m) => m.CrmToolsModule),
      },
      {
        path: "wallet",
        loadChildren: () =>
          import("./ModuleAndRouting/CRM/crm-wallet/crm-wallet.module").then((m) => m.CrmWalletModule),
      },
      {
        path: "web-commerce",
        loadChildren: () =>
          import("./ModuleAndRouting/CRM/crm-web-commerce/crm-web-commerce.module").then((m) => m.CrmWebCommerceModule),
      },
      {
        path: "feedback-manager",
        loadChildren: () =>
          import("./ModuleAndRouting/CRM/crm-feedback-manager/crm-feedback-manager.module").then((m) => m.CrmFeedbackManagerModule),
      }
    ]
  },

  {
    path: 'admin',
    children: [
      {
        path: "app-setup",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-app-setup/admin-app-setup.module").then((m) => m.AdminAppSetupModule),
      },
      {
        path: "business-setup",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-business-setup/admin-business-setup.module").then((m) => m.AdminBusinessSetupModule),
      },
      {
        path: "communication-setup",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-communication-setup/admin-communication-setup.module").then((m) => m.AdminCommunicationSetupModule),
      },
      {
        path: "crm-setup",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-crm-setup/admin-crm-setup.module").then((m) => m.AdminCrmSetupModule),
      },
      {
        path: "database-setup",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-database-setup/admin-database-setup.module").then((m) => m.AdminDatabaseSetupModule),
      },
      {
        path: "hardware-setup",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-hardware-setup/admin-hardware-setup.module").then((m) => m.AdminHardwareSetupModule),
      },
      {
        path: "manage-user",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-manage-user/admin-manage-user.module").then((m) => m.AdminManageUserModule),
      },
      {
        path: "master",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-master/admin-master.module").then((m) => m.AdminMasterModule),
      },
      {
        path: "transaction-setup",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-transaction-setup/admin-transaction-setup.module").then((m) => m.AdminTransactionSetupModule),
      },
      {
        path: "backup-restore",
        loadChildren: () =>
          import("./ModuleAndRouting/Admin/admin-backup-restore/admin-backup-restore.module").then((m) => m.AdminBackupRestoreModule),
      }
    ]
  },

  {
    path: 'report',
    children: [
      {
        path: "summary",
        loadChildren: () =>
          import("./ModuleAndRouting/Report/summary-report/summary-report.module").then((m) => m.SummaryReportModule),
      },
      {
        path: "executive",
        loadChildren: () =>
          import("./ModuleAndRouting/Report/executive-report/executive-report.module").then((m) => m.ExecutiveReportModule),
      },
      {
        path: "detail",
        loadChildren: () =>
          import("./ModuleAndRouting/Report/detail-report/detail-report/detail-report.module").then((m) => m.DetailReportModule),
      },
      {
        path: "edit-trail",
        loadChildren: () =>
          import("./ModuleAndRouting/Report/audit-trail/audit-trail.module").then((m) => m.AuditTrailModule),
      },
      {
        path: "activity-log",
        loadChildren: () =>
          import("./ModuleAndRouting/Report/logs-report/logs-report.module").then((m) => m.LogsReportModule),
      },
      {
        path: "reconciliation",
        loadChildren: () =>
          import("./ModuleAndRouting/Report/reconciliation-report/reconciliation-report.module").then((m) => m.ReconciliationReportModule),
      }
    ]
  },

  {
    path: 'shipping',
    children: [
      {
        path: "rider",
        loadChildren: () =>
          import("./ModuleAndRouting/Shipping/shipping-rider/shipping-rider.module").then((m) => m.ShippingRiderModule),
      },
      {
        path: "shippings",
        loadChildren: () =>
          import("./ModuleAndRouting/Shipping/shipping-shippings/shipping-shippings.module").then((m) => m.ShippingShippingsModule),
      },
      {
        path: "shipping-reports",
        loadChildren: () =>
          import("./ModuleAndRouting/Shipping/shipping-shipping-reports/shipping-shipping-reports.module").then((m) => m.ShippingShippingReportsModule),
      }
    ]
  },
  {
    path: 'hr',
    children: [
      {
        path: "setup",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/policy-set-up/policy-set-up.module").then((m) => m.PolicySetUpModule),
      },
      {
        path: "enrollment",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/enrollment/enrollment.module").then((m) => m.EnrollmentModule),
      },
      {
        path: "attendance",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/attendance/attendance.module").then((m) => m.AttendanceModule),
      },
      {
        path: "leave",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/leave/leave.module").then((m) => m.LeaveModule),
      },
      {
        path: "payroll",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/payroll/payroll.module").then((m) => m.PayrollModule),
      },
      {
        path: "expense",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/expense/expense.module").then((m) => m.ExpenseModule),
      },
      {
        path: "loans",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/loans/loans.module").then((m) => m.LoansModule),
      },
      {
        path: "food-coupon",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/food-coupon/food-coupon.module").then((m) => m.FoodCouponModule),
      },
      {
        path: "communication",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/communication/communication.module").then((m) => m.CommunicationModule),
      },
      {
        path: "appraisal",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/appriasal/appriasal.module").then((m) => m.AppriasalModule),
      },
      {
        path: "recruitment",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/recruitment/recruitment.module").then((m) => m.RecruitmentModule),
      },
      {
        path: "exit",
        loadChildren: () =>
          import("./ModuleAndRouting/HR/exit/exit.module").then((m) => m.ExitModule),
      },
      {
        path: 'track',
        loadChildren: () =>
          import('./ModuleAndRouting/HR/track/track.module')
            .then(m => m.TrackModule)
      }
    ],
  },

  {
    path: 'subscription',
    children: [
      {
        path: "subscription",
        loadChildren: () =>
          import("./ModuleAndRouting/Subscription/subscription-plan/subscription-plan.module")
            .then((m) => m.SubscriptionPlanModule),
      },
    ]
  },

  // {
  //   path: 'hr',
  //   children: [
  //     { path: '**', component: HRDashboardComponent },
  //   ],
  // },
  {
    path: 'appointment',
    component: AppointmentComponent
  },
  {
    path: 'gatepass',
    component: GatePassComponent
  },
  {
    path: 'permission',
    component: PermissionComponent
  },

  //Below all are report modules


  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent
  },
  {
    path: 'order/order/finishedgood',
    component: ModuleMaintenanceComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  }
  ,
  {
    path: 'monitoring-dashboard',
    component: MonitoringDashboardComponent
  }

  ,
  {
    path: 'okta-login',
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  // { path: 'login', redirectTo: 'okta-login', pathMatch: 'full' },
  { path: 'okta-login', redirectTo: 'login', pathMatch: 'full' },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    useHash: false
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
